import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "game-rating" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "Rating", -1)
const _hoisted_3 = { class: "field" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { for: "lasting_appeal" }, "Lasting appeal", -1)
const _hoisted_5 = { class: "field" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "replayability" }, "Replayability", -1)
const _hoisted_7 = { class: "field" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { for: "gameplay" }, "Gameplay", -1)
const _hoisted_9 = { class: "field" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { for: "depth" }, "Depth", -1)
const _hoisted_11 = { class: "field" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { for: "graphics" }, "Graphics", -1)

import { PropType, reactive, watch } from 'vue';
import { Rating as RatingModel } from '@/models/rating.model';
import Rating from '@/components/rating/Rating.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'GameRating',
  props: {
  modelValue: {
    type: Object as PropType<RatingModel>,
    required: true,
  },
},
  emits: ['update:modelValue'],
  setup(__props, { emit }) {

const props = __props;



const rating = reactive<RatingModel>(props.modelValue);

watch(
  props,
  () => {
    Object.assign(rating, props.modelValue);
  },
  { deep: true },
);



const updateRating = () => {
  emit('update:modelValue', rating);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode(Rating, {
        onInput: updateRating,
        modelValue: rating.lasting_appeal,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((rating.lasting_appeal) = $event))
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createVNode(Rating, {
        onInput: updateRating,
        modelValue: rating.replayability,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((rating.replayability) = $event))
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createVNode(Rating, {
        onInput: updateRating,
        modelValue: rating.gameplay,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((rating.gameplay) = $event))
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _createVNode(Rating, {
        onInput: updateRating,
        modelValue: rating.depth,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((rating.depth) = $event))
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _hoisted_12,
      _createVNode(Rating, {
        onInput: updateRating,
        modelValue: rating.graphics,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((rating.graphics) = $event))
      }, null, 8, ["modelValue"])
    ])
  ]))
}
}

})